export const filterActiveBankLinks = (accountBankLinks) => {
  const bankLinks = [];
  let hasDeletedBankLinks = false;
  accountBankLinks.forEach((link) => {
    if (link.status === 'A') {
      bankLinks.push(link);
    }
    if (link.status === 'D') {
      hasDeletedBankLinks = true;
    }
  });
  return {
    bankLinks,
    hasDeletedBankLinks,
  };
};

export default {
  filterActiveBankLinks,
};



// WEBPACK FOOTER //
// ./src/helpers/filterActiveBankLink.js